import React from "react";
import { ShapeToolbar } from "./components";
/**
 * Main RAD shapes component that renders the shape toolbar
 */
const RADShapes = () => {
  return <ShapeToolbar />;
};

export default React.memo(RADShapes);
